import React, { Component } from "react";
import "./selected_desk_mobile.css"
import dotenv from 'dotenv';
import Helper from '../../Devices/DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,
    update_state_item,
    update_request_graph_by_sensor,
    update_mobile_actual_dev_sensor_fields,
    t_get_all_projects,
    t_get_project_desks_by_user_and_project_id,
    //t_get_devlist_by_desk_id_and_user_id,
    //t_get_sensorlist_by_desk_id_and_user_id,
    t_get_mobile_devlist_skeleton_by_desk_id_and_user_id,
    t_collect_sensorsdata_by_devs_skeleton_mobile,
    t_update_request_graph_rx_data_mobile,
    t_update_request_graph_rx_data_mobile_pattern_mode,

    t_graph_update_graph_selectedDate_by_devId_and_sensorId,
    t_graph_update_graph_field_prop_by_devId_and_sensorId,
    t_update_request_graph_by_devId_and_sensorId,
    t_update_request_graph_rx_data,
    update_modal_chart,
} from "../../reducers/dev";

import { Card, Button, Row, Col, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import ModalChart from "../../Devices/DevServices/ModalChart"
import SDMa01accordionWrap from './SDMa01accordionWrap'

//import "./selecteddesk.css"

///run/user/1000/gvfs/sftp:host=xtal.asia,user=venus/home/venus/docker/4028-29-30_wifi_api_react/app/frontend/src/Devices/DevServices/Chart.jsx

dotenv.config();

class PageSelectedDesk extends Component {

/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */

  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
    this.props.update_state_item('selected_desk', {})
  }
  
  componentDidMount(){
    const rx_desk_id = this.props.match.params.desk_id
    this.props.update_state_item('selected_desk_id', rx_desk_id)
    //console.log(rx_desk_id)
    //get data for this desk
    //console.log('PageSelectedDesk: ', rx_desk_id)
/*     this.props.t_get_devlist_by_desk_id_and_user_id()
    this.props.t_get_sensorlist_by_desk_id_and_user_id()
 */
    this.props.t_get_mobile_devlist_skeleton_by_desk_id_and_user_id()
    //test mode
    //this.props.t_get_and_update_sensor_last_value_by_state_devs_mobile()
    this.props.t_collect_sensorsdata_by_devs_skeleton_mobile()
    // Set up the interval to fetch data every 5 seconds
    this.interval = setInterval(() => {
      this.props.t_collect_sensorsdata_by_devs_skeleton_mobile()
      console.log('PageSelectedDesk. Refresh data timer. 2min')
    }, 2*60*1000);  //2min


  } 

  render() {
    // Check if the user is authenticated or exists
    if (!this.props.user) {
      // Redirect to an external URL
      //window.location.href = "https://google.com";
      window.location.href = process.env.REACT_APP_HOST+"/login";
      return null; // Return null to avoid rendering anything else
    }
    //Get Projects by user_role
    
//style={{ fontWeight: 'bold' }}

    //console.log(this.props.dev.selected_desk_skeleton_mobile)
    return (
    <div className="psdm__content">
      
{/*       <button onClick={()=> {
        //this.props.t_update_request_graph_rx_data_mobile()
        this.props.t_collect_sensorsdata_by_devs_skeleton_mobile()
      }}>Hello</button> */}

      <SDMa01accordionWrap 
      selected_desk_skeleton_mobile = {this.props.dev.selected_desk_skeleton_mobile}
      update_mobile_actual_dev_sensor_fields = {this.props.update_mobile_actual_dev_sensor_fields}
      t_update_request_graph_rx_data_mobile= {this.props.t_update_request_graph_rx_data_mobile}
      t_update_request_graph_rx_data_mobile_pattern_mode = {this.props.t_update_request_graph_rx_data_mobile_pattern_mode}
      //t_graph_update_graph_selectedDate_by_devId_and_sensorId={this.props.t_graph_update_graph_selectedDate_by_devId_and_sensorId}
      />




      {/* <p>look: {this.props.dev.clickedMenu}</p> */}
{/*     <h4 className="text-secondary">Selected Project: <span className="text-primary" >{this.props.dev?.selected_project_desks?.projectName}</span></h4>
    
    {DevsExample(this.props.dev.selected_project_desks.desks)} */}


{/*       <DevList data = {this.props.dev.selected_desk}
      isLoading = {this.props.dev.isLoading}
      />

      <SensorList 
      data = {this.props.dev.selected_desk_sensorList}
      t_graph_update_graph_selectedDate_by_devId_and_sensorId={this.props.t_graph_update_graph_selectedDate_by_devId_and_sensorId}
      t_graph_update_graph_field_prop_by_devId_and_sensorId = {this.props.t_graph_update_graph_field_prop_by_devId_and_sensorId}
      t_update_request_graph_by_devId_and_sensorId = {this.props.t_update_request_graph_by_devId_and_sensorId} 
      t_update_request_graph_rx_data = {this.props.t_update_request_graph_rx_data} 
      />
      
      <ModalChart 
            update_modal_chart = {this.props.update_modal_chart}
            isModal={this.props.dev.modalChart.isModal}
            modalTitle = {this.props.dev.modalChart.modalTitle}
            sensor_data_for_modal = {this.props.dev.request_graph_by_sensor.rx_data_by_date.rows}
            />
 */}
      {/* <ModalChart 
            update_modal_chart = {1}
            isModal={true}
            modalTitle = {"this.props.dev.modalChart.modalTitle"}
            sensor_data_for_modal = {[]}
            /> */}

      <ModalChart 
            update_modal_chart = {this.props.update_modal_chart}
            isModal={this.props.dev.modalChart.isModal}
            modalTitle = {this.props.dev.modalChart.modalTitle}
            sensor_data_for_modal = {this.props.dev.request_graph_by_sensor.rx_data_by_date.rows}
            />

      <Helper props={this.props.dev} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,
    update_state_item,
    update_request_graph_by_sensor,
    update_mobile_actual_dev_sensor_fields,
    t_get_all_projects,
    t_get_project_desks_by_user_and_project_id,
    //t_get_devlist_by_desk_id_and_user_id,
    //t_get_sensorlist_by_desk_id_and_user_id,
    t_get_mobile_devlist_skeleton_by_desk_id_and_user_id,
    t_collect_sensorsdata_by_devs_skeleton_mobile,
    t_update_request_graph_rx_data_mobile,
    t_update_request_graph_rx_data_mobile_pattern_mode,
   
    t_graph_update_graph_selectedDate_by_devId_and_sensorId,
    t_graph_update_graph_field_prop_by_devId_and_sensorId,
    t_update_request_graph_by_devId_and_sensorId,
    t_update_request_graph_rx_data,
    update_modal_chart,
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageSelectedDesk);

